import ConditionedComponent from "components/ConditionedComponent.js"
import Discogs from 'discogs/Discogs.js';
import {newSampleByArtist, newRelease, getRelease} from 'decentralized/artists/Artists.js';
import {
    getSoundsWithDiscogs,
    getSoundsWithTag,
    getSoundsWithVideo,
    getSoundsWithUserBlockNumber} from 'search/getSounds.js';
import {getThumbnails} from './getThumbnails.js';
import SampleTooltip from './SampleTooltip.js';
import SampleInfo from './SampleInfo.js';
import React, { useRef, useEffect, useCallback, useState} from 'react';
import {SAMPLE_ANNOTATION} from 'constants/annotation-types.js';
import Sample from 'repos/Sample.js';
import Colors from "components/Colors.js";
import {connect} from 'react-redux';
import ethereum from "decentralized/ethereum.js";
import {
    setSampleDragging} from "actions/index.js";
    
let id = 0;
let counter = 0;
const colors = new Colors();
const SAMPLES_TO_SHOW = 64;
const discogs = new Discogs();

const SampleExplorer = ({
    setTagSelected,
    setSampleDragging,
    sample,
    track,
    tagSelected,
    audioUnit,
    pendingTransactions}) => { 

        let ref = useRef(undefined);
        let [start, setStart] = useState(0);
        let [showSamples, setShowSamples] = useState(false);
        let [samples, setSamples] = useState([]);
        let [thumbnails, setThumbnails] = useState({});
        let [annotations, setAnnotations] = useState(new Set());

        const onMouseDown = useCallback(async (s) => {
            if (s !== sample.ipfsHash) {
                return;
            }
            audioUnit.playSound();
        }, [sample]);
        
        useEffect(() => {
            setShowSamples(false);
        }, [setShowSamples, track]);
        const onMouseUp= useCallback(async (s) => {
            if (s !== sample.ipfsHash) {
                return;
            }
            audioUnit.stopSound();
        }, [sample]);

        const onClickSample = useCallback(async (s) => {
            if (s === sample.ipfsHash) {
                return;
            }
            let _counter = ++counter;
            let s2 = new Sample(s);
            await s2.load();
            if (_counter === counter) {
                track.auditionSound(s2);
            }
        }, [track, sample]);

        useEffect(() => {
            ref.current.scrollTo(0, 0);
            setStart(0);
        }, [tagSelected, track, setStart]);

        useEffect(() => {
            if (tagSelected) {
                getSoundsWithTag(tagSelected)
                    .then(sounds => setSamples(sounds));
                return;
            }

            if (sample.videoId) {
                getSoundsWithVideo(sample.videoId)
                    .then(sounds => setSamples(sounds));
            } else if (sample.discogsId) {
                getSoundsWithDiscogs(sample.discogsId)
                    .then(sounds => {
                        setSamples(sounds);
                    });
            } else {
                getSoundsWithUserBlockNumber(sample.sampledByUser, sample.blockNumber)
                    .then(sounds => setSamples(sounds));
            }
        }, [sample, setSamples, tagSelected, sample.videoId, sample.discogsId]);

        useEffect(() => {
            getThumbnails(samples)
                .then(t => setThumbnails(t));
            onScroll();
        }, [samples, setThumbnails]);
        

        useEffect(() => {
            setTagSelected(undefined);
        }, [track]);

        useEffect(() => {
            ethereum.xanadu.getAnnotations(
                SAMPLE_ANNOTATION)
                .then(a => {
                    setAnnotations(new Set(a.map(x => x.data)))
                });
        }, [setAnnotations, pendingTransactions]);

        useEffect(() => {
            ref.current.addEventListener('scroll', onScroll);
            return () => {
                ref.current.removeEventListener('scroll', onScroll);
            };
        }, [setStart, start, samples]);

        const onScroll = useCallback((e) => {
            let i = ++id;
            setTimeout(() => {
                if (i !== id || !ref.current) {
                    return;
                }
                let el = ref.current;
                let scrollTop = el.scrollTop + el.offsetHeight;
                if (scrollTop >= el.scrollHeight - 20) {
                    if (samples.length > start + SAMPLES_TO_SHOW) {
                        setStart(start + SAMPLES_TO_SHOW);
                    }
                }
            }, 100);
        }, [setStart, samples, start]);

        const onDragStart = useCallback((sample) => {
            setSampleDragging(sample);
        }, []);

        /*
        useEffect(() => {
            if (sample.discogsId) {
                getRelease(sample.discogsId).then(
                    async (r) => {
                        if (!r) {
                            let release = await discogs.getReleaseInfo(sample.discogsId);
                            console.log("RELEASE FETCHED = ", release);
                            sample.artistName = release.artists[0].name;
                            sample.releaseName = release.title;
                            sample.releaseType = 'RECORD';
                            newRelease(
                                sample.artistName,
                                sample.discogsId,
                                sample.releaseName,
                                sample.coverArtHash,
                                "RECORD");
                            newSampleByArtist(
                                sample.artistName,
                                sample.ipfsHash
                            );
                        }
                    });
            }
        }, [sample]);
        */

        let samplesToShow = showSamples ? samples.slice(0, start + SAMPLES_TO_SHOW) : [];
        return (
            <div className="sample-explorer">
              {tagSelected ?
               <div className="info">
                 {samples.length} 
                 <span
                   onClick={() => setShowSamples(!showSamples)}
                   className={showSamples ? "samples-button selected" : "samples-button"}
                 >
                   sounds
                 </span>
                 with this tag
               </div>  :
               <div className="info">
                 {samples.length} 
                 <span
                   onClick={() => setShowSamples(!showSamples)}
                   className={showSamples ? "samples-button selected" : "samples-button"}
                 >
                   sounds
                 </span>
                 from this source
               </div>}
              <div ref={ref} className="samples-from-source">
                {samplesToShow.map(
                    (x, i) =>
                        <SampleInfo
                          thumbnail={thumbnails[x]}
                          key={'sample-'+ i}
                          onDragStart={(e) => onDragStart(x)}
                          onMouseDown={() => onMouseDown(x)}
                          position={i % 6}
                          onMouseUp={() => onMouseUp(x)}
                          sequencerEngine={track.sequencerEngine}
                          annotations={annotations}
                          onDragOver={(e) => e.stopPropagation()}
                          onClickSample={() => onClickSample(x)}
                          sampleId={x}
                          sample={sample}/>
                )}
              </div>
              <SampleTooltip/>
            </div>
        );
}

const mapStateToProps = (state, props) => {
  return {
      pendingTransactions: state.transactions.pendingTransactions
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
        setSampleDragging: (sample) => dispatch(setSampleDragging(sample)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SampleExplorer);
